import { EvsbMailOfferFormComponent } from './evsb-mail-offer-form.component';
import { Component, OnDestroy, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'evsb-evsb-mail-offer-form',
  templateUrl: './evsb-mail-offer-form-modal.component.html',
})
export class MailOfferFormModalComponent implements OnDestroy {
  @ViewChild(EvsbMailOfferFormComponent) mailOfferForm: EvsbMailOfferFormComponent;

  private notifier = new Subject<void>();

  constructor(private title: Title, private translate: TranslateService) {
    this.translate.onLangChange.pipe(takeUntil(this.notifier)).subscribe(() => {
      this.title.setTitle(this.translate.instant('modules.evsb.pages.title.mailOfferForm'));
    });
  }

  ngOnDestroy(): void {
    this.notifier.next();
    this.notifier.complete();
  }

  public submitData() {
    this.mailOfferForm.submit();
  }
}
